<template>
  <add-record
    :title="((companyName) ? 'Add' : 'New') + ' Sales Order'"
    :pageInfo="localPageInfo"
    :modalId="'add-sales-order-modal'"
    :fields="quoteLineFields"
    :gridId="gridId"
    :onSuggestNameChange="onSuggestNameChange"
    :onSuggestNameSelect="onSuggestNameSelect"
    :getListOfNames="getListOfNames"
    :suggestionList="customerList"
    :resetModal="resetModal"
    :saveRecord="saveSalesOrder"
    :items="itemData"
    :sortMethod="onGetData"
    :showFilters="showFilters"
    :contactsArr="contacts"
    :filterValObj="filterValObj"
    :navigationField="'partNumber'"
    :getDataMethod="onGetData"
    @addItemClick="onShowModal"
    :isCompanyNameDefined="companyName != undefined"
    @updateCheckedRowItemIds="checkedQuoteLineItemIds = $event"
    class="mr-2">
    <template v-slot:headerSlot>
      <h6>{{ !companyId ? 'Please find your customer and then select' : ' Select' }} any open quotes from the grid below, or "Add" a new Sales Order.</h6>
    </template>
  </add-record>
</template>

<script>

import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import { CUSTOMER_ID, GRID_ID } from '@/shared/constants';
import AddRecord from '@/shared/components/AddRecord';
import quoteLineFields from '@/pages/Quotes/components/QuoteLines/fields';

export default {
  name: 'Addsalesorder',
  components: {
    AddRecord
  },
  props: {
    companyId: [Number, String],
    companyName: [String],
  },
  data: () => ({
    quoteLineFields,
    selectedAccount: {},
    filterValObj: {
      id: null,
      companyId: null,
      companyName: null,
      contactId: null
    },
    showFilters: {
        customer: true,
        contact: true
      },
    checkedQuoteLineItemIds: [],
    gridId: GRID_ID.SALES_ORDERS_ADD_GRID,
    customerList: [],
    localPageInfo: {}
  }),
  computed: {
    // ...mapGetters('quoteAdd', [
    //   'customers',
    //   'contacts',
    //   'filteredQuoteLines'
    // ]),
    ...mapGetters('quoteLines', {qLineList: 'gridList', qLinePageInfo: 'pageInfo'}),
    ...mapGetters('quoteAdd', [
      'contacts',
      'filteredQuoteLines'
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData(){
      return this.qLineList || [];
    }
  },
  methods: {
    ...mapMutations('quoteLines', {qLineSetItem: 'setItem', qLineSetFilter: 'setFilters'}),
    ...mapMutations('quoteAdd', {quoteAddSetItem: 'setItem'}),
    ...mapActions('quoteLines', {getQuoteLines: 'getAll', sortGrid: 'sortGrid'}),
    ...mapActions('companies', ['getByNameAndAccountType']),
    ...mapActions('quoteAdd', ['getContacts', 'getCompanyQuoteLines']),

    ...mapActions('salesOrders', [
      'createSOFromQuoteLine',
    ]),
    async resetModal() {
      if (!this.companyId && !this.companyName) {
        this.filterValObj.id = null;
        this.filterValObj.companyId = null;
        this.filterValObj.contactId = null;
        // this.clearCompanyQuoteLines();
        // this.clearContacts();
        // this.quoteAddSetItem({ resource: 'companyQuoteLines', payload: [] });
        // this.quoteAddSetItem({ resource: 'filteredQuoteLines', payload: [] });
        this.quoteAddSetItem({ resource: 'contacts', payload: [] });
      }
      this.checkedQuoteLineItemIds = [];
    },
    async onSuggestNameChange(val) {
      if (val === '') {
        this.resetModal();
      }
    },
    async onSuggestNameSelect(suggestion) {
      this.selectedAccount = suggestion;
      this.filterValObj.id = suggestion.id;
      this.filterValObj.companyId = suggestion.id;
      this.filterValObj.companyName = suggestion.name;
      this.getContacts(suggestion.id);
      this.onGetData({ ...this.localPageInfo, pageNumber: 1 });
    },
    async onGetData(params) {
      if (this.filterValObj.companyId) {
        const results = await this.getQuoteLines({
          ...params,
          filters: {
            companyId: this.filterValObj.companyId,
            statuses: [206]
          },
          isSavePageInfo: false,
        });
        this.localPageInfo = { ...this.localPageInfo, ...results.paging };
      }
    },
    async getListOfNames(name) {
      this.customerList = await this.getByNameAndAccountType({
        typeId: CUSTOMER_ID, name});

      return this.customerList;
    },
    async saveSalesOrder() {
      let companyId = this.filterValObj.companyId ? this.filterValObj.companyId : 0;
      let contactId = this.filterValObj.contactId ? this.filterValObj.contactId : 0;
      let lines = this.checkedQuoteLineItemIds;

      const result = await this.createSOFromQuoteLine({
        companyId: companyId,
        contactId: contactId,
        quoteLinesIds: lines
      });

      let id = result.data.id;

      this.$router.push({ name: 'salesorders.edit', params: { id }});

      this.resetModal();
    },
    onShowModal() {
      let companyId= parseInt(this.companyId);
      if (this.filterValObj.companyId != companyId) {
        this.onSuggestNameSelect({
          id: companyId,
          name: this.companyName
        });  
      } if (this.filterValObj.companyName != this.companyName) {
        this.filterValObj.companyName = this.companyName;
      } if (this.contacts.length == 0) {
        this.getContacts(companyId);
      } else if (this.itemData.length == 0) {
        this.onGetData({ ...this.localPageInfo,  pageNumber: 1 });
      }
    }
  },
  created() {
    this.qLineSetItem({ resource:'gridList', payload: [] });
    this.localPageInfo = { ...this.gridSettings.sort, ...this.gridSettings.pageSize };

    // if (this.companyId && this.companyName) {
    //   this.onSuggestNameSelect({
    //     id: parseInt(this.companyId),
    //     name: this.companyName
    //   });
    // }
  }
};
</script>
